import { call, put, takeLatest } from 'redux-saga/effects';

import { portalActions as actions } from '.';
import { PortalAction, Response } from './types';
import { request } from '../../../helpers/request';
import { API } from './constants';

export function* getCurrentUserGenerator() {
  try {
    const response: Response = yield call(request, API.GET_CURRENT_USER, {}, true);
    if (response.success) {
      yield put(actions.getCurrentUserSucceeded(response.data));
    } else {
      yield put(actions.getCurrentUserFailed());
    }
  } catch (err) {
    yield put(actions.getCurrentUserFailed());
  }
}

export function* getChatSessionsGenerator({ payload: data }: PortalAction) {
  try {
    const response: Response = yield call(request, API.GET_CHAT_SESSIONS, data, true);
    if (response.success) {
      yield put(actions.getChatSessionsSucceeded(response.data));
    } else {
      yield put(actions.getChatSessionsFailed());
    }
  } catch (err) {
    yield put(actions.getChatSessionsFailed());
  }
}

export function* deleteChatSessionGenerator({ payload: data }: PortalAction) {
  try {
    const response: Response = yield call(request, API.DELETE_CHAT_SESSION, { id: data }, true);
    if (response.success) {
      yield put(actions.deleteChatSessionSucceeded());
    } else {
      yield put(actions.deleteChatSessionFailed());
    }
  } catch (err) {
    yield put(actions.deleteChatSessionFailed());
  }
}

export function* getCurrentChatSessionGenerator({ payload: data }: PortalAction) {
  try {
    const response: Response = yield call(request, API.GET_CHAT_SESSION, { id: data }, true);
    if (response.success) {
      yield put(actions.getCurrentChatSessionSucceeded(response.data));
    } else {
      yield put(actions.getCurrentChatSessionFailed());
    }
  } catch (err) {
    yield put(actions.getCurrentChatSessionFailed());
  }
}
export function* logoutGenerator({ payload: data }: PortalAction) {
  try {
    const response: Response = yield call(request, API.LOGOUT, {}, true);
    if (response.success) {
      yield put(actions.logoutSucceeded());
      localStorage.removeItem(`token-${process.env.REACT_APP_PUBLIC_URL}`);
      localStorage.removeItem(`refresh-token-${process.env.REACT_APP_PUBLIC_URL}`);
      window.location.href = '/';
    } else {
      yield put(actions.logoutFailed());
    }
  } catch (err) {
    yield put(actions.logoutFailed());
  }
}

export function* connectUserGenerator({ payload: data }: PortalAction) {
  try {
    const response: Response = yield call(request, API.CONNECT_USER, data, true);
    if (response.success) {
      yield put(actions.connectUserSucceeded(response.data));
    } else {
      yield put(actions.connectUserFailed());
    }
  } catch (err) {
    yield put(actions.connectUserFailed());
  }
}

export function* portalSaga() {
  yield takeLatest(actions.getCurrentUser.type, getCurrentUserGenerator);
  yield takeLatest(actions.getChatSessions.type, getChatSessionsGenerator);
  yield takeLatest(actions.deleteChatSession.type, deleteChatSessionGenerator);
  yield takeLatest(actions.getCurrentChatSession.type, getCurrentChatSessionGenerator);
  yield takeLatest(actions.logout.type, logoutGenerator);
  yield takeLatest(actions.connectUser.type, connectUserGenerator);
}
export default portalSaga;
